// CMQCB La boutique : comportements partages
(function(){ // tiroir menu : ouverture, focus gardé dans le tiroir, Échap, fermeture au clic sur un lien
  var drawer=document.getElementById('drawer'),scrim=document.getElementById('scrim'),btn=document.getElementById('menuBtn');
  if(!drawer||!scrim||!btn) return;
  btn.setAttribute('aria-expanded','false'); btn.setAttribute('aria-controls','drawer');
  var focusables=function(){return [].slice.call(drawer.querySelectorAll('a[href],button:not([disabled])')).filter(function(e){return e.offsetParent!==null})};
  var isOpen=function(){return drawer.classList.contains('open')};
  function open(){drawer.classList.add('open');scrim.classList.add('open');document.body.classList.add('menu-open');btn.setAttribute('aria-expanded','true');drawer.setAttribute('aria-hidden','false');
    var f=focusables(); setTimeout(function(){(f[0]||drawer).focus({preventScroll:true})},60)}
  function close(back){if(!isOpen())return;drawer.classList.remove('open');scrim.classList.remove('open');document.body.classList.remove('menu-open');btn.setAttribute('aria-expanded','false');drawer.setAttribute('aria-hidden','true');
    if(back!==false) btn.focus({preventScroll:true})}
  btn.addEventListener('click',function(){isOpen()?close():open()});
  var x=document.getElementById('drawerClose'); if(x)x.addEventListener('click',function(){close()});
  scrim.addEventListener('click',function(){close()});
  drawer.addEventListener('click',function(e){if(e.target.closest('a[href]')) close(false)});
  document.addEventListener('keydown',function(e){
    if(!isOpen()) return;
    if(e.key==='Escape'){e.preventDefault();close();return}
    if(e.key==='Tab'){var f=focusables(); if(!f.length) return; var first=f[0],last=f[f.length-1];
      if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}
      else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}}
  });
})();
(function(){ // accordeon du pied de page (mobile)
  document.querySelectorAll('.acc-head').forEach(function(h){
    h.addEventListener('click',function(){h.parentElement.classList.toggle('open')});
  });
})();
(function(){ // pop-up newsletter, une fois par visiteur, jamais par-dessus la bannière cookies
  var scrim=document.getElementById('popScrim'); if(!scrim) return;
  var KEY='cb-popup-seen';
  function close(){scrim.classList.remove('on');try{localStorage.setItem(KEY,'1')}catch(e){}}
  var x=document.getElementById('popX'); if(x)x.addEventListener('click',close);
  var no=document.getElementById('popNo'); if(no)no.addEventListener('click',close);
  scrim.addEventListener('click',function(e){if(e.target===scrim)close()});
  // textes « pendant la vente » si la vente est ouverte
  var strip=document.querySelector('.sale-strip[data-opens-ts]');
  var ts=strip?parseInt(strip.getAttribute('data-opens-ts')||'0',10):0;
  if(ts&&Date.now()>=ts*1000) scrim.classList.add('is-live');
  var seen=false; try{seen=localStorage.getItem(KEY)==='1'}catch(e){}
  if(seen) return;
  var shown=false, armed=false, delay=parseInt(scrim.dataset.delay||'0',10), pct=parseInt(scrim.dataset.scroll||'50',10);
  function cartFull(){var c=document.querySelector('.cart-count');return c&&!c.hidden&&parseInt(c.textContent,10)>0}
  function show(){if(shown||!armed||cartFull()||document.body.classList.contains('cart-open')||bannerVisible())return;shown=true;scrim.classList.add('on')}
  function arm(){
    if(armed) return; armed=true;
    if(delay>0) setTimeout(show,delay);
    function onScroll(){if(window.scrollY+window.innerHeight>document.body.scrollHeight*(pct/100)) show()}
    window.addEventListener('scroll',onScroll,{passive:true}); onScroll();
    if(window.matchMedia('(pointer:fine)').matches){ // ordinateur : intention de sortie
      document.addEventListener('mouseout',function(e){if(!e.relatedTarget&&e.clientY<=0) show()});
    }
  }
  // on attend que le visiteur ait répondu à la bannière cookies (ou qu'il n'y en ait pas)
  document.addEventListener('visitorConsentCollected',function(){setTimeout(arm,600)});
  // la bannière est en position fixe : offsetParent y vaut toujours null, on mesure donc sa taille réelle à l'écran
  function bannerVisible(){
    var b=document.getElementById('shopify-pc__banner'); if(!b) return false;
    var cs=getComputedStyle(b), r=b.getBoundingClientRect();
    return r.width>0&&r.height>0&&cs.display!=='none'&&cs.visibility!=='hidden'&&parseFloat(cs.opacity||'1')>0;
  }
  function check(){
    var cp=window.Shopify&&window.Shopify.customerPrivacy;
    if(cp&&typeof cp.shouldShowBanner==='function'){
      if(!cp.shouldShowBanner()){arm();return}
      // secours : Shopify annonce une bannière qui ne s'affiche pas, on n'attend pas indéfiniment
      setTimeout(function(){if(!bannerVisible()) arm()},4000);
      return;
    }
    if(!bannerVisible()) arm();
  }
  try{
    if(window.Shopify&&typeof window.Shopify.loadFeatures==='function'){
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(err){if(err){setTimeout(check,3000);return}check()});
    } else setTimeout(check,3000);
  }catch(e){setTimeout(check,3000)}
})();
(function(){ // lecteur video en fenetre : cartes video (accueil, conseils cuisson) et bouton du producteur.
  // Retouche 8 : mini-lecteur. Pendant la lecture, un défilement (molette, pavé) ou un glissement vertical au doigt réduit la vidéo
  // en vignette en haut à droite, sous le menu (loin de la barre Commander et du chat) ; elle continue de jouer et la page redevient défilable.
  // Un appui sur la vignette la ré-agrandit, la croix la ferme.
  var isVideo=function(u){return /\.(mp4|m3u8|mov)(\?|#|$)/i.test(u||'')||/cdn\.shopify\.com\/videos\//.test(u||'')};
  var box=null, vid=null, last=null, mini=false, ty=0, tx=0;
  // Retouche 15 : lecture adaptative. Pour une vidéo Shopify (…/videos/c/vp/<id>/<id>.…mp4), on lit le flux HLS <id>.m3u8 :
  // nativement sur Safari / iOS, sinon via hls.js chargé au premier clic (cdnjs, version fixe). Le mp4 720p du lien reste le dernier recours.
  var HLSJS='https://cdnjs.cloudflare.com/ajax/libs/hls.js/1.5.20/hls.light.min.js', HLSSRI='sha512-0s8n7c3gYvZ9AbTehEn4YmRfMwOdbQB4Y0zysqUU9hMgMwL+irdqHtkZP5j3okZn8s8OykM5j/zYMDZWQJILyg==';
  var hls=null, hlsLoad=null, seq=0;
  function m3u8(u){if(/^https:\/\/cdn\.shopify\.com\/videos\/c\/vp\/[0-9a-f]{32}\/[0-9a-f]{32}\.m3u8$/i.test(u||'')) return u;var m=/^(https:\/\/cdn\.shopify\.com\/videos\/c\/vp\/([0-9a-f]{32})\/)\2\.[^\/?#]+\.mp4/i.exec(u||'');return m?m[1]+m[2]+'.m3u8':''}
  function loadHls(){
    if(window.Hls) return Promise.resolve(window.Hls);
    if(!hlsLoad) hlsLoad=new Promise(function(ok,ko){var s=document.createElement('script');s.src=HLSJS;s.integrity=HLSSRI;s.crossOrigin='anonymous';s.onload=function(){window.Hls?ok(window.Hls):ko()};s.onerror=function(){hlsLoad=null;ko()};document.head.appendChild(s)});
    return hlsLoad;
  }
  function killHls(){if(hls){hls.destroy();hls=null}}
  function play(){var p=vid.play(); if(p&&p.catch) p.catch(function(){if(vid.paused&&box) box.classList.add('tap')})}
  function setSrc(url){
    var n=++seq, h=m3u8(url); killHls();
    if(!h){vid.src=url;play();return}
    var nat=!!vid.canPlayType('application/vnd.apple.mpegurl');
    // Safari / iOS : HLS natif. Ailleurs (Chrome lit aussi le HLS natif mais monte en 1080p dans un lecteur de 400 px) : hls.js, plafonné à 720p (la taille du lecteur, poids réduit).
    if(nat&&/Apple/.test(navigator.vendor||'')){vid.src=h;play();return}
    vid.removeAttribute('src');
    loadHls().then(function(Hls){
      if(n!==seq) return;
      if(!Hls.isSupported()){vid.src=nat?h:url;play();return}
      hls=new Hls({maxBufferLength:20,maxMaxBufferLength:30}); // 20 s d'avance au plus : on ne télécharge pas toute la vidéo si elle est arrêtée tôt
      hls.on(Hls.Events.MANIFEST_PARSED,function(ev,d){var c=-1;d.levels.forEach(function(l,i){if(l.height<=720)c=i});if(c>=0)hls.autoLevelCapping=c});
      hls.on(Hls.Events.ERROR,function(ev,d){if(d.fatal&&n===seq){killHls();vid.src=url;play()}});
      hls.loadSource(h); hls.attachMedia(vid); play();
    },function(){if(n===seq){vid.src=url;play()}});
  }
  function build(){
    box=document.createElement('div'); box.className='vbox'; box.setAttribute('role','dialog'); box.setAttribute('aria-modal','true'); box.setAttribute('aria-label','Vidéo');
    // Retouche 23 : sous chaque vidéo, un bouton vers le colis. Sur la fiche produit, il ferme la vidéo et remonte en haut ;
    // sur une page qui contient la carte de la vente (#vente, accueil), il ferme la vidéo et descend jusqu'à elle ; sinon, lien vers la fiche.
    var onProduct=/^\/products\//.test(location.pathname), sale=document.getElementById('vente'), pl=document.querySelector('a[href*="/products/"]');
    var stay=onProduct||!!sale, go=stay?'#':(pl?pl.getAttribute('href'):'/collections/all');
    box.innerHTML='<div class="vbox-in"><button type="button" class="vbox-x" aria-label="Fermer">×</button><video controls playsinline preload="metadata"></video><button type="button" class="vbox-play" aria-label="Lire la vidéo"></button></div><a class="vbox-more vbox-go" href="'+go+'">Voir le colis <span aria-hidden="true">→</span></a>';
    document.body.appendChild(box); vid=box.querySelector('video');
    vid.addEventListener('play',function(){box.classList.remove('tap')});
    box.querySelector('.vbox-play').addEventListener('click',function(e){e.stopPropagation();box.classList.remove('tap');var p=vid.play();if(p&&p.catch)p.catch(function(){})});
    if(stay) box.querySelector('.vbox-go').addEventListener('click',function(e){e.preventDefault();close();if(onProduct)window.scrollTo({top:0,behavior:'smooth'});else sale.scrollIntoView({behavior:'smooth',block:'start'})});
    box.addEventListener('click',function(e){
      if(e.target.closest('.vbox-x')){close();return}
      if(mini){if(e.target.closest('.vbox-in')){e.preventDefault();expand()}return}
      if(e.target===box) close();
    });
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&box.classList.contains('on')) close()});
    box.addEventListener('wheel',function(e){if(!mini&&Math.abs(e.deltaY)>4) shrink()},{passive:true});
    box.addEventListener('touchstart',function(e){var p=e.touches[0];ty=p.clientY;tx=p.clientX},{passive:true});
    box.addEventListener('touchmove',function(e){
      if(mini) return; var p=e.touches[0], dy=p.clientY-ty, dx=p.clientX-tx;
      if(Math.abs(dy)>40&&Math.abs(dy)>Math.abs(dx)*1.5) shrink();
    },{passive:true});
  }
  function open(url,poster){
    if(!box) build();
    if(mini){mini=false;box.classList.remove('mini');box.setAttribute('aria-modal','true');vid.controls=true}
    if(poster) vid.poster=poster; else vid.removeAttribute('poster');
    box.classList.remove('tap'); box.classList.add('on'); document.body.classList.add('video-open');
    setSrc(url);
    box.querySelector('.vbox-x').focus({preventScroll:true});
  }
  function shrink(){ // vignette : la vidéo continue, la page se libère
    if(!box.classList.contains('on')||mini) return; mini=true;
    box.classList.add('mini'); box.setAttribute('aria-modal','false'); document.body.classList.remove('video-open');
    vid.controls=false; box.querySelector('.vbox-in').setAttribute('aria-label','Agrandir la vidéo');
  }
  function expand(){
    mini=false; box.classList.remove('mini'); box.setAttribute('aria-modal','true'); document.body.classList.add('video-open');
    vid.controls=true; box.querySelector('.vbox-in').removeAttribute('aria-label');
    var p=vid.play(); if(p&&p.catch) p.catch(function(){});
  }
  function close(){
    seq++; killHls(); vid.pause(); vid.removeAttribute('src'); vid.load();
    mini=false; box.classList.remove('mini'); vid.controls=true;
    box.classList.remove('on'); document.body.classList.remove('video-open');
    if(last) last.focus({preventScroll:true});
  }
  document.addEventListener('click',function(e){
    var a=e.target.closest('a[href]'); if(!a||!isVideo(a.getAttribute('href'))) return;
    if(e.metaKey||e.ctrlKey||e.shiftKey) return; // ouverture volontaire dans un nouvel onglet
    e.preventDefault(); last=a;
    var img=a.querySelector('img')||(a.closest('.video-ph')&&a.closest('.video-ph').querySelector('img'));
    open(a.getAttribute('href'),img?(img.currentSrc||img.src):'');
  });
  // Retouche 23 : ?video=<id de 32 caractères> ouvre la vidéo à l'arrivée. On reprend le lien de la page s'il existe (avec sa vignette),
  // sinon on lit directement le flux Shopify. Le paramètre est retiré de l'adresse pour qu'un rechargement ne la rouvre pas.
  try{
    var q=new URLSearchParams(location.search), id=(q.get('video')||'').toLowerCase();
    if(/^[0-9a-f]{32}$/.test(id)){
      var a=document.querySelector('a[href*="/videos/c/vp/'+id+'/"]'), img=a&&(a.querySelector('img')||(a.closest('.video-ph')&&a.closest('.video-ph').querySelector('img')));
      q.delete('video'); history.replaceState(null,'',location.pathname+(q.toString()?'?'+q:'')+location.hash);
      open(a?a.getAttribute('href'):'https://cdn.shopify.com/videos/c/vp/'+id+'/'+id+'.m3u8',img?(img.currentSrc||img.src):'');
    }
  }catch(e){}
})();
(function(){ // lot 8 : compteur unique « Il vous reste x j y h pour commander » jusqu'à la fin de la vente (la date n'est jamais affichée)
  var els=document.querySelectorAll('[data-countdown]'); if(!els.length) return;
  function txt(ms){
    var m=Math.floor(ms/60000), d=Math.floor(m/1440), h=Math.floor((m%1440)/60), mn=m%60;
    return d>0?d+' j '+h+' h':h+' h '+mn+' min';
  }
  function upd(){
    [].forEach.call(els,function(el){
      var end=parseInt(el.getAttribute('data-end')||'0',10)*1000; if(!end) return;
      var left=end-Date.now(), t=el.querySelector('[data-cdn-t]');
      el.classList.toggle('is-over',left<=0);
      if(left>0&&t) t.textContent=txt(left);
    });
  }
  upd(); setInterval(upd,30000);
  document.addEventListener('visibilitychange',function(){if(!document.hidden) upd()});
})();
(function(){ // lot 8 : bouton « Commander » : ajoute 1 colis puis ouvre la page panier ; déjà dans le panier : ouvre le panier sans en ajouter
  var cartUrl=((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/')+'cart';
  function release(f){
    f.classList.remove('is-busy');
    var btns=[].slice.call(f.querySelectorAll('[type="submit"]'));
    if(f.id) btns=btns.concat([].slice.call(document.querySelectorAll('[type="submit"][form="'+f.id+'"]')));
    btns.forEach(function(b){b.disabled=false;b.removeAttribute('aria-busy')});
  }
  document.addEventListener('submit',function(e){
    var f=e.target; if(!f||!f.matches||!f.matches('form[data-buy]')) return;
    e.preventDefault();
    if(f.classList.contains('is-busy')) return;
    var vid=parseInt(f.getAttribute('data-variant')||'0',10), err=f.querySelector('[data-buy-error]');
    var btns=[].slice.call(f.querySelectorAll('[type="submit"]'));
    if(f.id) btns=btns.concat([].slice.call(document.querySelectorAll('[type="submit"][form="'+f.id+'"]')));
    f.classList.add('is-busy'); if(err) err.hidden=true;
    btns.forEach(function(b){b.disabled=true;b.setAttribute('aria-busy','true')});
    fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(c){
      var inCart=(c.items||[]).some(function(it){return it.variant_id===vid});
      if(inCart){window.location.href=cartUrl;return}
      return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:vid,quantity:1}]})})
        .then(function(r){if(!r.ok) throw new Error('add');window.location.href=cartUrl});
    }).catch(function(){
      release(f);
      if(err) err.hidden=false; // notre message, jamais celui de Shopify (il peut citer le stock restant)
    });
  });
  // retour arrière depuis le panier : la page peut revenir du cache avec le bouton grisé
  window.addEventListener('pageshow',function(){document.querySelectorAll('form[data-buy].is-busy').forEach(release)});
})();
(function(){ // lot 8 : page panier, boutons − et + (la page se recharge avec les nouveaux montants)
  var form=document.getElementById('cart8'); if(!form) return;
  var err=form.querySelector('[data-c8-error]');
  function change(line,qty){
    form.classList.add('busy');
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:line,quantity:qty})})
      .then(function(r){if(!r.ok) throw new Error('change');window.location.reload()})
      .catch(function(){form.classList.remove('busy');if(err) err.hidden=false});
  }
  form.addEventListener('click',function(e){
    var b=e.target.closest('[data-c8]'); if(!b) return;
    var it=b.closest('.c8-item'), line=parseInt(it.getAttribute('data-line'),10), q=parseInt(it.getAttribute('data-qty'),10);
    var n=Math.max(0,q+parseInt(b.getAttribute('data-c8'),10));
    it.querySelector('.qty-in').value=n; change(line,n);
  });
  form.addEventListener('change',function(e){
    var inp=e.target.closest('.qty-in'); if(!inp) return;
    var it=inp.closest('.c8-item'), n=Math.max(0,parseInt(inp.value,10)||0);
    change(parseInt(it.getAttribute('data-line'),10),n);
  });
  form.addEventListener('keydown',function(e){if(e.key==='Enter'&&e.target.closest('.qty-in')){e.preventDefault();e.target.blur()}});
})();
(function(){ // lot 8 : carrousels (pièces du colis, recettes, vidéos), flèches ← → ; retouche 7 : aussi sur mobile, une carte par appui
  document.querySelectorAll('.box-rail-wrap').forEach(function(w){
    var rail=w.querySelector('[data-rail]'); if(!rail) return;
    function step(){var c=rail.firstElementChild;return c?c.getBoundingClientRect().width+14:260}
    function state(){w.classList.toggle('no-scroll',rail.scrollWidth<=rail.clientWidth+8);w.classList.toggle('at-start',rail.scrollLeft<8);w.classList.toggle('at-end',rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-8)}
    w.addEventListener('click',function(e){var b=e.target.closest('[data-rail-go]');if(!b)return;rail.scrollBy({left:step()*(innerWidth<900?1:2)*parseInt(b.getAttribute('data-rail-go'),10),behavior:'smooth'})});
    rail.addEventListener('scroll',state,{passive:true}); window.addEventListener('resize',state); window.addEventListener('load',state); state();
  });
})();
(function(){ // lot 8 : aperçu des fonds du haut de page sans passer par l'éditeur : ?cochons=points (retouche 11), ?cochons=dense, ?cochons=leger ou ?cochons=aucun
  var m=/[?&]cochons=(points|dense|leger|aucun)/.exec(location.search); if(!m) return;
  var cls={points:'pigs--points',dense:'pigs--dense',leger:'pigs--light',aucun:'pigs--none'}[m[1]];
  document.querySelectorAll('.pigs').forEach(function(el){el.classList.remove('pigs--points','pigs--dense','pigs--light','pigs--none');el.classList.add(cls)});
})();
(function(){ // lot 8 : hauteur de l'en-tête (les liens du menu vers les ancres s'arrêtent juste dessous) ; repris de l'ancienne bande de vente
  var h=document.querySelector('.hdr2'); if(!h) return;
  function s(){document.documentElement.style.setProperty('--hdr-h',h.offsetHeight+'px')}
  s(); window.addEventListener('resize',s); window.addEventListener('load',s);
})();
(function(){ // lot 8, retouche 1 : Emmanuelle ouvre le colis. Retouche 7 : 2 photos (fermé, ouvert) et un fondu de 0,4 s déclenché dès qu'on commence à défiler (plus de fondu suivi pixel par pixel, donc jamais d'image fantôme à l'arrêt) ; retour au colis fermé tout en haut ; sur ordinateur, ouverture seule 1,5 s après l'affichage si personne n'a défilé. « Réduire les animations » : colis fermé, photo ouverte jamais chargée
  var fig=document.querySelector('[data-colis-anim]'); if(!fig) return;
  if(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var a=fig.querySelectorAll('.h8-a'); if(a.length<2) return;
  var ready=false, want=false, scrolled=false, TOP=8;
  function y(){return window.scrollY||window.pageYOffset||0}
  function apply(){fig.classList.toggle('is-open',ready&&want)}
  function onScroll(){
    if(y()>TOP){scrolled=true;if(!want){want=true;apply()}}
    else if(want){want=false;apply()}
  }
  function loaded(i){return new Promise(function(ok){if(i.complete&&i.naturalWidth){ok();return} i.addEventListener('load',ok,{once:true});i.addEventListener('error',ok,{once:true})})}
  function load(){ // photo ouverte juste après la page ; le fondu attend qu'elle soit chargée (pas de trou)
    var i=a[1];
    if(i.dataset.srcset){i.srcset=i.dataset.srcset;i.removeAttribute('data-srcset')}
    if(i.dataset.src){i.src=i.dataset.src;i.removeAttribute('data-src')}
    loaded(i).then(function(){ready=true;fig.classList.add('is-anim');onScroll();apply()});
  }
  if(document.readyState==='complete') load(); else window.addEventListener('load',load);
  window.addEventListener('scroll',onScroll,{passive:true});
  if(window.matchMedia&&matchMedia('(min-width: 900px)').matches){ // ordinateur : la photo se voit sans défiler
    setTimeout(function(){if(!scrolled&&!want){want=true;apply()}},1500);
  }
})();

/* Lot 8, barre « Commander » fixe sur téléphone (accueil). Retouche 11 : logique simplifiée, sans IntersectionObserver.
   Visible dès que la carte du colis est dépassée (ou après 400 px si la carte n'a pas de bouton), cachée seulement
   quand le bouton de la carte est revenu à l'écran ou quand le pied de page arrive. Recalculée au défilement, au
   changement de taille ou d'orientation, à l'arrivée par une ancre et au retour arrière (pageshow).
   Calcul direct à chaque événement (deux mesures seulement), sans requestAnimationFrame. */
(function(){
  var bar=document.querySelector('[data-sb-home]');
  if(!bar) return;
  var hero=document.querySelector('.h8-buy form[data-buy]');
  var foot=document.querySelector('.ftr2');
  var btn=bar.querySelector('button');
  function upd(){
    var vh=window.innerHeight||document.documentElement.clientHeight;
    var past;
    if(hero&&hero.offsetParent!==null){past=hero.getBoundingClientRect().bottom<0}
    else{past=(window.pageYOffset||document.documentElement.scrollTop)>400}
    var end=foot?foot.getBoundingClientRect().top<vh-60:false;
    var on=past&&!end;
    if(bar.classList.contains('is-on')!==on){
      bar.classList.toggle('is-on',on);
      bar.setAttribute('aria-hidden',on?'false':'true');
      if(btn) btn.tabIndex=on?0:-1;
    }
  }
  ['scroll','resize','orientationchange','hashchange','load','pageshow'].forEach(function(ev){window.addEventListener(ev,upd,{passive:true})});
  if(btn) btn.tabIndex=-1;
  upd(); setInterval(function(){if(!document.hidden) upd()},500); // filet : certains téléphones n'envoient le défilement qu'à la fin du geste
})();

/* Lot 8, retouche 11 : indicateur de progression vertical, le long du bord droit (accueil, et fiche produit si elle est longue).
   Rail discret + remplissage jaune. Sur ordinateur, un repère par grande section (survol = nom, clic = y aller) ;
   sur téléphone, le remplissage seul, sans aucune zone tactile. Un seul écouteur de défilement passif. */
(function(){
  var home=!!document.querySelector('.hero8'), prod=location.pathname.indexOf('/products/')>-1, cg=document.getElementById('colis-guide');
  if(!home&&!prod&&!cg) return; // retouche 13 : aussi la page « Votre colis »
  var de=document.documentElement;
  var rail=document.createElement('div'); rail.className='prog8'; rail.setAttribute('aria-hidden','true');
  var fill=document.createElement('span'); fill.className='prog8-fill'; rail.appendChild(fill);
  var marks=[], wide=window.matchMedia&&matchMedia('(min-width: 900px) and (hover: hover)').matches;
  if((home||cg)&&wide){
    (cg?[['cg-pieces','Les pièces'],['cg-videos','Vidéos'],['cg-keep','Conserver'],['cg-laborie','Le cochon'],['cg-help','Un problème ?']]:
    [['vente','Le colis'],['presentation','La vente du moment'],['dedans',"Ce qu'il y a dedans"],['videos','Vidéos'],['concept','Le concept'],['faq','FAQ']]).forEach(function(m){
      var el=document.getElementById(m[0]); if(!el) return;
      var b=document.createElement('button'); b.type='button'; b.className='prog8-dot'; b.tabIndex=-1;
      b.innerHTML='<span>'+m[1]+'</span>';
      b.addEventListener('click',function(){window.scrollTo({top:el.getBoundingClientRect().top+window.pageYOffset-hdr()-8,behavior:'smooth'})});
      rail.appendChild(b); marks.push({el:el,b:b});
    });
  }
  document.body.appendChild(rail);
  function hdr(){var h=document.querySelector('.hdr2,header');var r=h&&h.getBoundingClientRect();var b=r&&r.top<=0&&r.bottom>0?r.bottom:0;
    var nv=cg&&cg.querySelector('.cg-nav');return b+(nv?nv.offsetHeight:0)} // page « Votre colis » : les pastilles collent sous l'en-tête
  function place(){
    var max=de.scrollHeight-window.innerHeight;
    rail.classList.toggle('is-off',(prod||cg)&&de.scrollHeight<window.innerHeight*3);
    if(cg){var h=document.querySelector('.hdr2'),nv=cg.querySelector('.cg-nav');rail.style.top=((h?h.offsetHeight:0)+(nv?nv.offsetHeight:0)+14)+'px'}
    marks.forEach(function(m){
      var t=m.el.getBoundingClientRect().top+window.pageYOffset-hdr();
      m.p=max>0?Math.min(1,Math.max(0,t/max)):0;
      m.b.style.top=(m.p*100)+'%';
    });
    upd();
  }
  function upd(){
    var max=de.scrollHeight-window.innerHeight, p=max>0?Math.min(1,Math.max(0,(window.pageYOffset||de.scrollTop)/max)):0;
    fill.style.transform='scaleY('+p.toFixed(4)+')';
    for(var i=0;i<marks.length;i++) marks[i].b.classList.toggle('is-past',p>=marks[i].p-0.002);
  }
  window.addEventListener('scroll',upd,{passive:true});
  window.addEventListener('resize',place);
  window.addEventListener('load',place);
  place(); setTimeout(place,1500);
})();

(function(){ // lot 8, retouche 12 : accroche de l'en-tête. Sur téléphone, mode « dessous » : copie placée juste sous l'en-tête (non fixe).
  // Aperçu sans toucher au réglage : ?accroche=dedans | dessous | aucune
  var h=document.querySelector('.hdr2'), k=h&&h.querySelector('[data-hook]'); if(!k) return;
  var m=/[?&]accroche=(dedans|dessous|aucune)/.exec(location.search);
  if(m){h.className=h.className.replace(/hdr2--hook-m-\w+/,'')+' hdr2--hook-m-'+m[1]}
  if(!/hdr2--hook-m-dessous/.test(h.className)) return;
  var sec=h.closest('.shopify-section')||h, c=document.createElement('div');
  c.className='hook-below '+k.className.replace('hdr2-hook','').trim(); c.setAttribute('role','note');
  c.innerHTML=k.innerHTML;
  sec.parentNode.insertBefore(c,sec.nextSibling);
})();
(function(){ // lot 8, retouche 13 : pages légales, tableaux à en-têtes (confidentialité) lisibles sur téléphone : chaque cellule reçoit l'intitulé de sa colonne
  document.querySelectorAll('.shopify-policy__body table').forEach(function(t){
    var rows=t.querySelectorAll('tr'); if(!rows.length) return;
    var head=[].map.call(rows[0].children,function(c){return c.textContent.trim()});
    if(!rows[0].querySelector('th')) return;
    t.classList.add('pol-stack');
    for(var i=1;i<rows.length;i++) [].forEach.call(rows[i].children,function(c,j){if(head[j]) c.setAttribute('data-label',head[j])});
  });
})();
(function(){ // Retouche 18 : bannière cookies. Shopify ne l'ouvre pas toujours d'elle-même (constaté le 2/11 en France, même sur le thème Horizon) :
  // on charge l'API de consentement et, si Shopify dit qu'il faut la montrer et que le visiteur n'a pas encore choisi, on l'ouvre nous-mêmes.
  function visible(){
    var b=document.getElementById('shopify-pc__banner'); if(!b) return false;
    var cs=getComputedStyle(b), r=b.getBoundingClientRect();
    return r.width>0&&r.height>0&&cs.display!=='none'&&cs.visibility!=='hidden';
  }
  // getTrackingConsent() vaut « yes » ou « no » une fois le choix fait (y compris un refus) ; shouldShowBanner() reste vrai après un choix.
  function undecided(cp){
    try{var t=cp.getTrackingConsent(); return t!=='yes'&&t!=='no'}catch(e){return false}
  }
  function open(){
    var cp=window.Shopify&&window.Shopify.customerPrivacy;
    if(!cp||typeof cp.shouldShowBanner!=='function'||!cp.shouldShowBanner()||!undecided(cp)||visible()) return;
    if(window.privacyBanner&&typeof window.privacyBanner.showBanner==='function'){try{window.privacyBanner.showBanner()}catch(e){}}
  }
  function start(){
    if(!window.Shopify||typeof window.Shopify.loadFeatures!=='function') return;
    try{window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(err){if(!err) setTimeout(open,1200)})}catch(e){}
  }
  if(document.readyState==='complete') start(); else window.addEventListener('load',start);
})();
